/**
 * @fileoverview Commonly used string operations. Use lodash when
 * applicable!
 */

import { ensureArray } from './array'

/**
 * Convert a variable list of arguments into a lower case,
 * separator-delineated string, where non-word characters are replaced with
 * the configured separator (hyphen by default).
 * @param {Object} options
 * @param {array} options.items
 * @param {string} options.separator
 * @returns {string}
 */
export function slugify({ items, separator = '-' }) {
  return ensureArray(items)
    .join(separator)
    .toLowerCase()
    .replace(/\W/g, separator)
}

/**
 * Capitalizes the string.
 *
 * @export
 * @param {*} string
 * @returns
 */
export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * Splits the string on the character and ensures all values are trimmed.
 *
 * @export
 * @param {*} string String to split.
 * @param {*} on Character to split on.
 * @returns
 */
export function split(string, on) {
  if (!string || string.length === 0) {
    return []
  }
  const values = string.trim().split(on)
  return values.map(value => value.trim())
}

/**
 * After splitting the string on the character, returns the last item in the list.
 *
 * @param {String} string
 * @param {String} on
 */
export function lastAfterSplit(string, on) {
  const list = split(string, on)
  if (list.length > 0) {
    return list[list.length - 1]
  } else {
    return null
  }
}

/**
 * Converts a snake-or-kebab-case string to camelCase.
 * 
 * @param {String} str kebab-case
 * @returns String camelCase
 */
export function snakeToCamel(str) {
  return str.replace(/([-_][a-z])/g, function(group) {
      return group.toUpperCase().replace(/[-_]/g, '');
  })
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/string.js